<script setup lang="ts">
import type { PropType } from 'vue'
import type { FieldConfigInterface } from '@voix/types'

const props = defineProps({

  fieldConfiguration: {
    type: Object as PropType<FieldConfigInterface>,
    required: true,
  },
})
</script>

<template>
  <div v-if=" props.fieldConfiguration.description" class="mt-4 space-y-1 border-t voix-admin-border-light pt-2">
    <div class="uppercase font-bold voix-admin-text-dark text-2xs">
      Description / Notes
    </div>
    <div class="text-sm border-l-4 voix-admin-border-dark pl-2 flex  items-center space-x-1">
      <div>{{ props.fieldConfiguration.description }}</div>
    </div>
  </div>
</template>
